var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCsm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91,
    height: 34,
    viewBox: "0 0 91 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CSM",
    transform: "translate(-7 -93.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_70_",
    transform: "translate(7 93.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_74_",
    d: "M98,101.823V99.532H67.145V97.173H59.823V93.5H45.144v3.639H37.822v2.392H7v2.291H37.855v2.392H10v2.291H37.855V108.9H12.991v2.291H37.855v2.426H15.987v2.291H37.855V118.3H18.982v2.291H37.822v2.426H21.978v2.291H37.822l-.033,2.19h7.323v-2.19H59.789v2.19h7.323v-2.19H82.955v-2.291H67.112v-2.426H85.951V118.3H67.112v-2.392H88.98v-2.291H67.112v-2.426H91.975V108.9H67.112v-2.392H94.971v-2.291H67.112v-2.392H98ZM52.5,95.05a4.381,4.381,0,1,1-4.327,4.381A4.345,4.345,0,0,1,52.5,95.05Zm7.356,28H45.177v-2.426H59.856Zm0-4.718H45.177v-2.392H59.856Zm0-4.684H45.177v-2.426H59.856Zm0-4.718H45.177v-2.392H59.856Z",
    transform: "translate(-7 -93.5)",
    fill: "#383b3b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_71_",
    transform: "translate(42.195 2.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_73_",
    d: "M145.8,100.2l-1.7,4.907h1.2v1.836h.8v-1.836h1.2Z",
    transform: "translate(-140.662 -100.2)",
    fill: "#383b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_72_",
    d: "M135.469,100.2l-1.669,4.907h1.168v1.836h.8v-1.836h1.2Z",
    transform: "translate(-133.8 -100.2)",
    fill: "#383b3b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsm);
export default __webpack_public_path__ + "static/media/csm.e41a96716cff77d63694c645e1457f11.svg";
export { ForwardRef as ReactComponent };